import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { tuftsCard } from '../tufts-card/tufts-card';
import componentStyles from './tufts-event-card.css.lit';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import '../tufts-heading/tufts-heading';
import '../tufts-icon/tufts-icon';

/**
 * The tuftsEventCard component
 * @element tufts-event-card
 *
 *
 * @attr no-clickable-card
 */
@customElement('tufts-event-card')
export class tuftsEventCard extends tuftsCard {
  static styles: CSSResultGroup = [componentStyles, tuftsHeadingCssLit];

  /**
   * Remove link and hover to no clickable card
   */
  @property({ type: Boolean, reflect: true, attribute: 'no-clickable-card' })
  noClickableCard = false;

  dateRender() {
    return html` ${this.ngSlot.conditionalNGSlot('date-month')}
    ${this.ngSlot.conditionalNGSlot('date-day')}`;
  }

  render(): TemplateResult {
    const classes = {
      'content-wrapper': true,
      'mobile': this.resizeController.currentBreakpointRange === 0,
    };
    const articleClass = {
      'card-wrapper': true,
      'no-clickable-card': this.noClickableCard,
    };
    return html`
      <article class="${classMap(articleClass)}">
        <div class="date-content">
          ${this.ngSlot.exist('date-month')
            ? this.dateRender()
            : html`<tufts-icon name="monitor" library="system"></tufts-icon>`}
        </div>
        <div class="${classMap(classes)}">
          ${this.ngSlot.conditionalNGSlot('eyebrow', true, 'xs')}
          ${this.ngSlot.conditionalNGSlot(
            'heading',
            true,
            'clickable-card md heading-color'
          )}
          ${this.ngSlot.conditionalNGSlot('hosting')}
          ${this.ngSlot.conditionalNGSlot('time')}
          ${this.ngSlot.conditionalNGSlot('location')}
          ${this.registerIconTemplate()}
        </div>
      </article>
    `;
  }
  registerIconTemplate() {
    return this.noClickableCard
      ? undefined
      : html` <div class="link" aria-hidden="true">Register ➞</div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-event-card': tuftsEventCard;
  }
}
